import type {
  BookingPolicySnapshot,
  BookingResourceSelectionMode,
  CustomerCaptureMode,
  ExtendedCustomerField,
  OptionalPolicyMode
} from "./bookingPolicy";

export type BookingPolicyForm = {
  bookingResourceSelectionMode: BookingResourceSelectionMode;
  customerCaptureMode: CustomerCaptureMode;
  extendedCustomerFields: ExtendedCustomerField[];
  presenceConfirmation: OptionalPolicyMode;
  autoReleaseUnconfirmed: boolean;
  confirmationDeadlineMinutes: string;
  arrivalCheckpoint: OptionalPolicyMode;
};

export function buildBookingPolicyForm(policy: BookingPolicySnapshot | undefined): BookingPolicyForm {
  return {
    bookingResourceSelectionMode: policy?.booking_resource_selection_mode ?? "customer_choice_or_any",
    customerCaptureMode: policy?.customer_capture_mode ?? "minimal",
    extendedCustomerFields: parseExtendedCustomerFields(policy?.extended_customer_fields),
    presenceConfirmation: policy?.presence_confirmation ?? "off",
    autoReleaseUnconfirmed: policy?.presence_confirmation === "required" && Boolean(policy.auto_release_unconfirmed),
    confirmationDeadlineMinutes: String(policy?.confirmation_deadline_minutes ?? 60),
    arrivalCheckpoint: policy?.arrival_checkpoint ?? "off"
  };
}

function parseExtendedCustomerFields(fields: string[] | undefined): ExtendedCustomerField[] {
  const supported: ExtendedCustomerField[] = ["birth_date", "preferred_service_id", "preferred_resource_id"];

  return supported.filter((field) => fields?.includes(field));
}
